import { render, staticRenderFns } from "./HumanCapitalWorkingAverageInput.vue?vue&type=template&id=04380666&scoped=true&"
import script from "./HumanCapitalWorkingAverageInput.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalWorkingAverageInput.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalWorkingAverageInput.vue?vue&type=style&index=0&id=04380666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04380666",
  null
  
)

export default component.exports